import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import translationEN from './locales/en/translation.json';
import gameEN from './locales/en/game.json';
import modalsEN from './locales/en/modals.json';
import seoEN from './locales/en/seo.json';
import storyEN from './locales/en/story.json';

import translationKO from './locales/ko/translation.json';
import gameKO from './locales/ko/game.json';
import modalsKO from './locales/ko/modals.json';
import seoKO from './locales/ko/seo.json';
import storyKO from './locales/ko/story.json';

// Translation resources
const resources = {
  en: {
    translation: translationEN,
    game: gameEN,
    modals: modalsEN,
    seo: seoEN,
    story: storyEN,
  },
  ko: {
    translation: translationKO,
    game: gameKO,
    modals: modalsKO,
    seo: seoKO,
    story: storyKO,
  },
};

// Custom language detector for Korean users
const languageDetector = new LanguageDetector();
languageDetector.addDetector({
  name: 'customDetector',
  lookup() {
    // Priority 1: Check localStorage
    const savedLang = localStorage.getItem('language');
    if (savedLang) return savedLang;

    // Priority 2: Check browser language
    const browserLang = navigator.language || navigator.userLanguage;
    if (browserLang.startsWith('ko')) {
      // Auto-detect Korean users
      return 'ko';
    }

    // Default to English
    return 'en';
  },
  cacheUserLanguage(lng) {
    localStorage.setItem('language', lng);
  },
});

i18n
  .use(languageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    defaultNS: 'translation',
    ns: ['translation', 'game', 'modals', 'seo', 'story'],

    detection: {
      order: ['customDetector', 'localStorage', 'navigator'],
      caches: ['localStorage'],
    },

    interpolation: {
      escapeValue: false, // React already escapes values
    },

    react: {
      useSuspense: false, // Disable suspense for simpler error handling
    },
  });

export default i18n;
